var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip w-fit whitespace-nowrap",attrs:{"data-tooltip":new Date(_vm.timestamp).toLocaleString()}},[_vm._v(" "+_vm._s(_setup.timeAgo(_vm.timestamp))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }